/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import proptypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { Typography } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
import { TileHead } from '../../TileHead';
import { formatInventory, showTodayOrTomorrow } from '../../../../helper/utils';
import { getDefaultStoreHours, showBopisDate } from '../../../../helper/timeZoneUtils';
import { IDS } from '../../../../../automationTestIds';

const {
  arrayOf, bool, number, shape, string, object
} = proptypes;

const StoreOnly = ({
  bopisFulfillment = null, itemId, isShipToHomeEligible = false, isAppliance = false, isCartTiles = false, pickupStoreHours = null
}) => {
  let { storeHours } = useStore();
  if (!storeHours) {
    storeHours = getDefaultStoreHours();
  }
  const pickupStoreHoursWithTZ = isCartTiles ? pickupStoreHours
    : { ...storeHours, ...pickupStoreHours };
  const localStoreLocation = (bopisFulfillment?.locations || []).find(
    (location) => location.isAnchor
  );
  const quantity = localStoreLocation?.inventory?.quantity;
  const formattedInventoryQty = formatInventory(quantity);
  const deliveryTimeline = bopisFulfillment?.deliveryTimeline;

  const renderBopisTimeline = () => (deliveryTimeline ? (
    showTodayOrTomorrow(
      null,
      true,
      deliveryTimeline,
      null
    )
  ) : (
    showBopisDate(pickupStoreHoursWithTZ, true)
  ));

  return (
    <div>
      <div className="sui-flex sui-items-center">
        <TileHead title="At Your Store" automationId={IDS.LABEL.atYourStoreLabel} />
      </div>
      <div data-testid="ffm-details-row" className="sui-pt-2">
        {quantity > 0 && (
          <>
            <Typography variant="body-base" color="text-colors-inactive" component="div">
              <div
                className="sui-font-bold sui-min-h-[24px] sui-pb-1"
                data-testid="pickupTimeline"
                data-automation-id={IDS.ETA.atYourStoreETA}
              >
                {renderBopisTimeline()}
                <div className="sui-inline-block sui-ml-1" data-testid="AtYourStoreInfoIcon">
                  <InfoFilled size="small" style={{ color: '#499992', verticalAlign: 'text-bottom' }} />
                </div>
              </div>
            </Typography>
            <Typography variant="body-base" component="div">
              <div
                className="sui-min-h-[24px]"
                data-testid="fulfillment-qty-row"
                data-automation-id={IDS.QTY.atYourStoreQty}
              >
                <span className="sui-text-success">{formattedInventoryQty}</span>
                {"\u00A0"}in stock
                {quantity === 0 && <span>Visit your store to check availability</span>}
              </div>
            </Typography>
          </>
        )}
      </div>
    </div>
  );

};
StoreOnly.propTypes = {
  itemId: string.isRequired,
  isShipToHomeEligible: bool,
  isAppliance: bool,
  bopisFulfillment: shape({
    type: string,
    locations: arrayOf(shape({
      isAnchor: bool,
      inventory: shape({
        quantity: number,
        isInStock: bool,
        isLimitedQuantity: bool,
        isBackordered: bool
      })
    }))
  }),
  isCartTiles: bool,
  // eslint-disable-next-line react/forbid-prop-types
  pickupStoreHours: object
};

export { StoreOnly };
